import { z } from "zod";

export const CrewEquipmentCapabilitySchema = z.object({
  id: z.string().uuid().describe("ID"),
  business_id: z.string().uuid().describe("Business"),
  account_id: z.string().uuid().describe("Account"),
  crew_id: z.string().uuid().describe("Crew"),
  equipment_type_id: z.string().uuid().describe("Equipment Type"),
  is_owned: z.boolean().describe("Owned"),
  is_subcontracted: z.boolean().describe("Subcontracted"),
  quantity: z.number().int().describe("Quantity"),
  notes: z.string().nullable().describe("Notes"),
  created_at: z.string().describe("Created At"),
  updated_at: z.string().describe("Updated At"),
});
export type CrewEquipmentCapability = z.infer<
  typeof CrewEquipmentCapabilitySchema
>;

export const CrewEquipmentCapabilityInsertSchema = z
  .object({
    crew_id: z.string().uuid().describe("Crew"),
    equipment_type_id: z.string().uuid().describe("Equipment Type"),
    is_owned: z.boolean().default(false).describe("Owned"),
    is_subcontracted: z.boolean().default(false).describe("Subcontracted"),
    quantity: z.number().int().min(1).default(1).describe("Quantity"),
    notes: z.string().optional().describe("Notes"),
  })
  .refine((d) => d.is_owned || d.is_subcontracted, {
    message: "At least one of is_owned or is_subcontracted must be true",
  });

export const CrewEquipmentCapabilityUpdateSchema = z.object({
  is_owned: z.boolean().optional().describe("Owned"),
  is_subcontracted: z.boolean().optional().describe("Subcontracted"),
  quantity: z.number().int().min(1).optional().describe("Quantity"),
  notes: z.string().optional().describe("Notes"),
});

export const CrewEquipmentCapabilityQuerySchema = z.object({
  // schema-check-ignore: query-filter — null/"" semantically distinct from "no filter applied"
  crew_id: z.string().uuid().optional(),
  // schema-check-ignore: query-filter — null/"" semantically distinct from "no filter applied"
  equipment_type_id: z.string().uuid().optional(),
  is_owned: z
    .string()
    .transform((v) => v === "true")
    .optional(),
});
